export default __webpack_public_path__ + "static/media/6.328689e3.png";